import { create } from 'zustand';
import { getMe } from '../api';
import api from '../api';

const TOKEN_KEY = 'musicapp_token';

const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem(TOKEN_KEY) || null,
  isLoading: true,

  setToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common['Authorization'] = `Token ${token}`;
    set({ token });
  },

  clearAuth: () => {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common['Authorization'];
    set({ user: null, token: null });
  },

  loadUser: async () => {
    const token = get().token;
    if (!token) {
      set({ isLoading: false });
      return;
    }
    api.defaults.headers.common['Authorization'] = `Token ${token}`;
    try {
      const res = await getMe();
      set({ user: res.data, isLoading: false });
    } catch (err) {
      // Only clear auth on explicit 401 — don't nuke the token on network errors
      if (err?.response?.status === 401) {
        get().clearAuth();
      }
      set({ isLoading: false });
    }
  },
}));

export default useAuthStore;